import React from 'react';
import PropTypes from 'prop-types';
import {
  gridPaginatedVisibleSortedGridRowIdsSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

import { getSelectionState } from '../../../../utils/selection';
import { StyledCheckBox } from '../../styles';

/**
 * "Select all" checkbox for a DataGrid column header, scoped to the rows on the current page.
 *
 * The page's rows are read from the grid's own state, so they already reflect the grid's filtering,
 * sorting and pagination. Checking it selects every row on the page, unchecking it deselects only those rows.
 */
const PageSelectionHeader = ({
  selectedIds,
  onSelectionChange,
  ariaLabel,
}) => {
  const apiRef = useGridApiContext();
  const pageRowIds = useGridSelector(apiRef, gridPaginatedVisibleSortedGridRowIdsSelector);
  const { checked, indeterminate } = getSelectionState(pageRowIds, selectedIds);

  return (
    <StyledCheckBox
      size="small"
      checked={checked}
      indeterminate={indeterminate}
      disabled={pageRowIds.length === 0}
      onChange={() => onSelectionChange(pageRowIds, !checked)}
      inputProps={{ 'aria-label': ariaLabel }}
    />
  );
};

PageSelectionHeader.propTypes = {
  selectedIds: PropTypes.array.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

export default PageSelectionHeader;
